var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgNext(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 15,
    viewBox: "0 0 9 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.562 7.981l-6.749 6.57a.694.694 0 01-.974 0l-.407-.401a.675.675 0 010-.963L6.293 7.5.438 1.813a.675.675 0 010-.963L.845.448a.694.694 0 01.974 0l6.749 6.57a.68.68 0 01-.006.963z",
    fill: "#4E59F5"
  })));
}

export default __webpack_public_path__ + "./fonts/next.d3ae43f61aa5df63efd36c08c5bab619.svg";
export { SvgNext as ReactComponent };